import Button from "@mui/material/Button";
import React from "react";
import { API_HOST } from "../utils";
function LandingPage({ onImport, username }) {
  const loggedIn = username !== null && username !== "";
  return (
    <div className="landing">
      <h2>Welcome to BPM Binder</h2>
      {loggedIn ? (
        <>
          <p>Logged in as {username}</p>
          <Button className="btn" onClick={() => onImport(username)}>
            Import Collection
          </Button>
        </>
      ) : (
        <p>
          <Button
            component="a"
            className="discogs-login-btn"
            href={`${API_HOST}/auth/discogs/login/`}
          >
            <img src="/discogs-logo.svg" alt="Discogs" />
            Login
          </Button>
        </p>
      )}
    </div>
  );
}
export default LandingPage;
